import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { pageSizeList } from "@/utils/constant";
import { Button, Table, message, DatePicker, Pagination, Input, Select, Radio, Modal } from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class ProxyStatistic extends React.Component {
    state = {
        loading: false, // 是否加载中
        exportLoading: false, // 导出是否加载中
        recordLoading: false, // 记录是否加载中
        recordTitle: undefined, // 记录弹窗标题
        showRecord: false, // 是否显示记录弹窗
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            vendor_id: undefined,
            currency_code: undefined,
            date: [],
        },
        data: [], // 表格数据
        intervalSummaryData: [], // 区间汇总数据
        pageSizeList: pageSizeList, // 分页天数列表
        currencyCodeList: [], // 币种类型列表
        specificCurrencyCodeList: [], // 特定币种类型列表
    };

    async componentDidMount () {
        this.fetchData();
        this.fetchCurrencyCodeList();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/kpoker_union/sub_gain_stat", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                    specificCurrencyCodeList: res.extra ? [
                        { label: 'U', value: undefined },
                        { label: res.extra, value: res.extra },
                    ] : [],
                });
            });
    };

    /**
     * 获取区间汇总数据
     */
    fetchIntervalSummaryData = () => {
        this.setState({ recordLoading: true });
        axios
            .get("/v1/api/kpoker_union/sub_gain_range_stat", {
                params: {
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                },
            })
            .then((res) => {
                this.setState({
                    recordLoading: false,
                    intervalSummaryData: res.data || [],
                });
            });
    };

    /**
     * 获取币种类型列表
     */
    fetchCurrencyCodeList = async () => {
        axios.get("/v1/api/kpoker_union/coin_current_rate_list").then((res) => {
            this.setState({ currencyCodeList: res.data || [] });
        })
    };

    /**
     * 显示弹窗
     */
    handleShow = (type) => {
        if (type === "intervalSummaryData") {
            // 区间汇总记录
            this.setState({
                recordTitle: this.props.language["intervalSummaryData"],
                recordType: type,
                showRecord: true,
            }, () => this.fetchIntervalSummaryData());
        }
    };

    /**
     * 关闭弹窗
     */
    handleClose = (type) => {
        if (type === "intervalSummaryData") {
            // 区间汇总记录
            this.setState({ showRecord: false });
        }
    }

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/kpoker_union/sub_gain_stat_export", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, regain = false) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        }, () => {
            if (regain) this.fetchData()
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    vendor_id: undefined,
                    currency_code: undefined,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Input
                        maxLength={60}
                        allowClear
                        placeholder={this.props.language["proxyIdPlaceholder"]}
                        value={this.state.queryParams.vendor_id}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("vendor_id", e.target.value)
                        }
                    />
                    {this.state.specificCurrencyCodeList && this.state.specificCurrencyCodeList.length > 0 &&
                        <Radio.Group
                            value={this.state.queryParams.currency_code}
                            buttonStyle="solid"
                            onChange={(e) =>
                                this.handleSetQueryParamsData("currency_code", e.target.value, true)
                            }
                        >
                            {this.state.specificCurrencyCodeList.map((item, index) => (
                                <Radio.Button value={item.value} key={index}>
                                    {item.label}
                                </Radio.Button>
                            ))}
                        </Radio.Group>
                    }
                    {this.state.specificCurrencyCodeList && this.state.specificCurrencyCodeList.length === 0 &&
                        <Select
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            placeholder={this.props.language["displayCurrencyPlaceholder"]}
                            value={this.state.queryParams.currency_code}
                            onChange={(value) => this.handleSetQueryParamsData("currency_code", value)}
                        >
                            {this.state.currencyCodeList.map((item, index) => (
                                <Select.Option value={item.currency_code} key={index}>
                                    {item.currency_name}（{item.currency_code}）
                                </Select.Option>
                            ))}
                        </Select>
                    }
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow('intervalSummaryData')}
                    >
                        {this.props.language["intervalSummaryData"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={tableSummaries(this.state.data, "day")}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="day"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/proxy_detail/${item.vendor_id}`}>
                                    {item.vendor_id || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalGaveIn"]}
                            dataIndex="total_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["activityCost"]}
                            dataIndex="active_cost"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerProfit"]}
                            dataIndex="profit_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceProportion"]}
                            dataIndex="fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceProportion"]}
                            dataIndex="ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProportion"]}
                            dataIndex="cowboy_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["luckcardAndJackpotProfit"]}
                            dataIndex="lc_jp_gain_sum"
                        />
                        {Cookie.get("isKpoker") === 'true' &&
                            <Table.Column
                                align="center"
                                title={this.props.language["prop"]}
                                dataIndex="api_prop_cost_sum"
                            />
                        }
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhProfit"]}
                            dataIndex="nlh_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidProfit"]}
                            dataIndex="squid_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["superProfit"]}
                            dataIndex="super_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofProfit"]}
                            dataIndex="aof_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcProfit"]}
                            dataIndex="ofc_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttProfit"]}
                            dataIndex="mtt_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploProfit"]}
                            dataIndex="plo_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixProfit"]}
                            dataIndex="six_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProfit"]}
                            dataIndex="cb_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductFee"]}
                            dataIndex="nlh_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidDeductFee"]}
                            dataIndex="squid_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["superDeductFee"]}
                            dataIndex="super_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofDeductFee"]}
                            dataIndex="aof_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcDeductFee"]}
                            dataIndex="ofc_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttDeductFee"]}
                            dataIndex="mtt_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductFee"]}
                            dataIndex="plo_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductFee"]}
                            dataIndex="six_fee_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductFee"]} dataIndex="cb_fee_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductInsurance"]}
                            dataIndex="nlh_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidDeductInsurance"]}
                            dataIndex="squid_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["superDeductInsurance"]}
                            dataIndex="super_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["aofDeductInsurance"]} dataIndex="aof_ins_profit_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["ofcDeductInsurance"]} dataIndex="ofc_ins_fee_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["mttDeductInsurance"]} dataIndex="mtt_ins_profit_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductInsurance"]}
                            dataIndex="plo_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductInsurance"]}
                            dataIndex="six_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductInsurance"]} dataIndex="cb_ins_profit_sum" /> */}
                    </Table>
                    <Pagination
                        className="pagination"
                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                    />
                </div>

                {/* 查看记录弹窗 */}
                <RecordModal
                    {...this.props}
                    visible={this.state.showRecord}
                    title={this.state.recordTitle}
                    type={this.state.recordType}
                    loading={this.state.recordLoading}
                    intervalSummaryData={this.state.intervalSummaryData}
                    onCancel={() => this.handleClose('intervalSummaryData')}
                />
            </div>
        );
    }
}

/**
 * 查看记录弹窗
 */
class RecordModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                }}
                footer={null}
            >
                <div className="container-content">
                    <Table
                        dataSource={tableSummaries(this.props.intervalSummaryData, "day")}
                        pagination={false}
                        loading={this.props.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="day"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/proxy_detail/${item.vendor_id}`}>
                                    {item.vendor_id || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalGaveIn"]}
                            dataIndex="total_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["activityCost"]}
                            dataIndex="active_cost"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerProfit"]}
                            dataIndex="profit_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceProportion"]}
                            dataIndex="fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceProportion"]}
                            dataIndex="ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProportion"]}
                            dataIndex="cowboy_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["luckcardAndJackpotProfit"]}
                            dataIndex="lc_jp_gain_sum"
                        />
                        {Cookie.get("isKpoker") === 'true' &&
                            <Table.Column
                                align="center"
                                title={this.props.language["prop"]}
                                dataIndex="api_prop_cost_sum"
                            />
                        }
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhProfit"]}
                            dataIndex="nlh_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidProfit"]}
                            dataIndex="squid_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["superProfit"]}
                            dataIndex="super_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofProfit"]}
                            dataIndex="aof_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcProfit"]}
                            dataIndex="ofc_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttProfit"]}
                            dataIndex="mtt_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploProfit"]}
                            dataIndex="plo_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixProfit"]}
                            dataIndex="six_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProfit"]}
                            dataIndex="cb_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductFee"]}
                            dataIndex="nlh_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidDeductFee"]}
                            dataIndex="squid_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["superDeductFee"]}
                            dataIndex="super_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofDeductFee"]}
                            dataIndex="aof_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcDeductFee"]}
                            dataIndex="ofc_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttDeductFee"]}
                            dataIndex="mtt_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductFee"]}
                            dataIndex="plo_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductFee"]}
                            dataIndex="six_fee_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductFee"]} dataIndex="cb_fee_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductInsurance"]}
                            dataIndex="nlh_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidDeductInsurance"]}
                            dataIndex="squid_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["superDeductInsurance"]}
                            dataIndex="super_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["aofDeductInsurance"]} dataIndex="aof_ins_profit_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["ofcDeductInsurance"]} dataIndex="ofc_ins_fee_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["mttDeductInsurance"]} dataIndex="mtt_ins_profit_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductInsurance"]}
                            dataIndex="plo_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductInsurance"]}
                            dataIndex="six_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductInsurance"]} dataIndex="cb_ins_profit_sum" /> */}
                    </Table>
                </div>
            </Modal>
        );
    }
}

